module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "noindent centre"
  }, [_c('b', [_vm._v("Praise for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aftermath")]), _vm._v(" by LeVar Burton")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Deftly crafted … adds new depth and perspective to the science fiction genre.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Denver Post")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Epic, along the lines of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Stand")]), _vm._v("; spiritual, along the lines of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Seven Arrows. ")]), _vm._v("I highly recommend this book!” —Whoopi Goldberg")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A thoroughly entertaining debut.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Philadelphia Inquirer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“I was deeply moved. In LeVar Burton’s brilliantly realized cautionary tale, heroic men and women embody timeless values that will always make a difference—courage, passion, wisdom, and, most of all, love. I recommend this novel to anyone who cares about the human spirit.” —Anthony Robbins, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Awaken the Giant Within")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Assured prose, with a well-developed plot … [A] wise, above-average debut.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Thoroughly readable … [LeVar Burton] has mastered the art of keeping readers turning pages.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“An entertaining debut.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Plain Dealer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“An amazingly good first novel … builds tension with the best of them … Burton’s characters are believable; his protagonists are likable and his antagonist is one nasty dude.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rocky Mountain News")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Evocative … Adeptly told … Burton’s gift as a storyteller enthralls you.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("South Florida Sun-Sentinel")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f620084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 66
// module chunks = 0